<template>
  <div class="home">
    <tabs-live>
    </tabs-live>
    <tabbar></tabbar>
  </div>
</template>

<script>
import tabbar from '@/components/Tabbar' 
import tabsLive from '@/components/tabsLive' 

export default {
  components:{
    tabbar,
    tabsLive
  },
   data() {
    return {
      active: 0,
      icon: {
        active: 'https://img.yzcdn.cn/vant/user-active.png',
        inactive: 'https://img.yzcdn.cn/vant/user-inactive.png'
      }
    }
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title{
  display: none;
}
.van-tabs--line /deep/ .van-tabs__wrap {
    height: 40px;
    padding:  0 30px 0 0;
}
</style>




// WEBPACK FOOTER //
// src/pages/live/live.vue